import React, { useEffect, useState, Fragment } from 'react'
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  FormControl,
  InputGroup,
  OverlayTrigger,
  Row,
  Toast,
  Tooltip
} from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'

import {FaSearch} from 'react-icons/fa'
import { formato_monto } from '../../common/Formatos'



const Antecedentes = ({handleClose}) => {
  
   const data_antecedentes = useSelector((state) => state.AntecedentesJudicialesReducer)
   const { cfg_form27, datosAntecedentes} = data_antecedentes
   const data_recepciona = useSelector((state) => state.casoGeneralReducer)
   const { llaves} = data_recepciona
   
  return (
    <>
 <style type='text/css'>
      
    </style>
      
        <Card >
          <Card.Header
            className='mt-0 mb-0'
            as='h6'
            style={{ backgroundColor: '#4F517A', color: 'white' }}
          >
            {cfg_form27
              ? cfg_form27.cfg_form27['consultaantecjudicial-title-antecjudi']
              : ''} 
          </Card.Header>
          <Container>
           
            
              {cfg_form27? (
                <div >
                  
                  <Row >
                 
                    <Col md='3'>
                      <Form.Label
                        className='mb-2 mt-4'
                        style={{ fontWeight: 'bold', fontSize: '16px' }}
                      >
                        {
                          cfg_form27.cfg_form27[
                            'consultaantecjudicial-lbl-competencia'
                          ]
                        }
                      </Form.Label>{' '}
                      <br />
                      <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                        {datosAntecedentes && datosAntecedentes.datosAntecedentes[0]!==undefined &&
                        datosAntecedentes.datosAntecedentes[0]['competencia'] !== undefined &&
                        datosAntecedentes.datosAntecedentes[0]['competencia'] !== null &&
                        datosAntecedentes.datosAntecedentes[0]['competencia'] !== ''
                        ? datosAntecedentes.datosAntecedentes[0]['competencia']
                        : ''}
                </Form.Text>
                    </Col>
                    <Col md='3'>
                      <Form.Label
                       className='mb-2 mt-4'
                        style={{ fontWeight: 'bold', fontSize: '16px' }}
                      >
                        {
                          cfg_form27.cfg_form27[
                            'consultaantecjudicial-lbl-corte'
                          ]
                        }
                      </Form.Label>
                      <br />
                      <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                      {datosAntecedentes && datosAntecedentes.datosAntecedentes[0]!==undefined &&
                        datosAntecedentes.datosAntecedentes[0]['corte'] !== undefined &&
                        datosAntecedentes.datosAntecedentes[0]['corte'] !== null &&
                        datosAntecedentes.datosAntecedentes[0]['corte'] !== ''
                        ? datosAntecedentes.datosAntecedentes[0]['corte']
                        : ''}
                </Form.Text>
                   </Col>
                    
                   <Col md='3'>
                      <Form.Label
                        className='mb-2 mt-4'
                        style={{ fontWeight: 'bold', fontSize: '16px' }}
                      >
                        {
                          cfg_form27.cfg_form27[
                            'consultaantecjudicial-lbl-tribunal'
                          ]
                        }
                      </Form.Label>{' '}
                      <br />
                      <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                      {datosAntecedentes && datosAntecedentes.datosAntecedentes[0]!==undefined &&
                        datosAntecedentes.datosAntecedentes[0]['tribunal'] !== undefined &&
                        datosAntecedentes.datosAntecedentes[0]['tribunal'] !== null &&
                        datosAntecedentes.datosAntecedentes[0]['tribunal'] !== ''
                        ? datosAntecedentes.datosAntecedentes[0]['tribunal']
                        : ''}
                </Form.Text>
                     
                    </Col>  
                                  
                     
                
               </Row>
               <Row >
                 
                 <Col md='3'>
                   <Form.Label
                     className='mb-2 mt-4'
                     style={{ fontWeight: 'bold', fontSize: '16px' }}
                   >
                     {
                       cfg_form27.cfg_form27[
                         'consultaantecjudicial-lbl-libro'
                       ]
                     }
                   </Form.Label>{' '}
                   <br />
                   <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                   {datosAntecedentes && datosAntecedentes.datosAntecedentes[0]!==undefined &&
                        datosAntecedentes.datosAntecedentes[0]['libro'] !== undefined &&
                        datosAntecedentes.datosAntecedentes[0]['libro'] !== null &&
                        datosAntecedentes.datosAntecedentes[0]['libro'] !== ''
                        ? datosAntecedentes.datosAntecedentes[0]['libro']
                        : ''}
             </Form.Text>
                 </Col>
                 <Col md='3'>
                   <Form.Label
                    className='mb-2 mt-4'
                     style={{ fontWeight: 'bold', fontSize: '16px' }}
                   >
                     {
                       cfg_form27.cfg_form27[
                         'consultaantecjudicial-lbl-rol'
                       ]
                     }
                   </Form.Label>
                   <br />
                   <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                   {datosAntecedentes && datosAntecedentes.datosAntecedentes[0]!==undefined &&
                        datosAntecedentes.datosAntecedentes[0]['rolCausa'] !== undefined &&
                        datosAntecedentes.datosAntecedentes[0]['rolCausa'] !== null &&
                        datosAntecedentes.datosAntecedentes[0]['rolCausa'] !== ''
                        ? datosAntecedentes.datosAntecedentes[0]['rolCausa']
                        : ''}
             </Form.Text>
                </Col>
                 
                <Col md='3'>
                   <Form.Label
                     className='mb-2 mt-4'
                     style={{ fontWeight: 'bold', fontSize: '16px' }}
                   >
                     {
                       cfg_form27.cfg_form27[
                         'consultaantecjudicial-lbl-fechacausa'
                       ]
                     }
                   </Form.Label>{' '}
                   <br />
                   <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                   {datosAntecedentes && datosAntecedentes.datosAntecedentes[0]!==undefined &&
                        datosAntecedentes.datosAntecedentes[0]['fecIngresaCausaFormat'] !== undefined &&
                        datosAntecedentes.datosAntecedentes[0]['fecIngresaCausaFormat'] !== null &&
                        datosAntecedentes.datosAntecedentes[0]['fecIngresaCausaFormat'] !== ''
                        ? datosAntecedentes.datosAntecedentes[0]['fecIngresaCausaFormat']
                        : ''}
             </Form.Text>
                  
                 </Col>  
                <Col md='3'>
                   <Form.Label
                    className='mb-2 mt-4'
                     style={{ fontWeight: 'bold', fontSize: '16px' }}
                   >
                     {
                       cfg_form27.cfg_form27[
                         'consultasoldescuento-lbl-mtorecobro'
                       ]
                     }
                   </Form.Label>{' '}
                   <br />
                   <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                   {/* {datosSolicitud && datosSolicitud.datosSolicitud[0]!==undefined &&
                     datosSolicitud.datosSolicitud[0]['montoRecobro'] !== undefined &&
                     datosSolicitud.datosSolicitud[0]['montoRecobro'] !== null &&
                     datosSolicitud.datosSolicitud[0]['montoRecobro'] !== ''
                     ? formato_monto(datosSolicitud.datosSolicitud[0]['montoRecobro'])
                     : ''} */}
             </Form.Text>
                  
                 </Col>  
                               
                  
             
            </Row>
               
               <Row>
                 <Col>
                 <div >
                 
 
               <hr style={{ color: '#04005D', height: '2px', marginTop:'15px'}}></hr>
                   </div>
           
                 </Col>
               </Row>
             
           
           
          
            
                    </div>
              ) : null}
             
           
           <Row>
                <Col className='d-flex align-items-end justify-content-end m-2'>
                <Button className='m-2 w-auto' variant='outline-info' onClick={handleClose}   >
                {cfg_form27 && cfg_form27.cfg_form27["consultaantecjudicial-btn-cerrar"]}
                
          </Button>
          </Col>
           </Row>
     
      
   
          </Container>
        </Card>
     
     
    
    </>
  )
}

export default Antecedentes
